import { render, staticRenderFns } from "./gOrderList.vue?vue&type=template&id=3dba34a4&scoped=true"
import script from "./gOrderList.vue?vue&type=script&lang=js"
export * from "./gOrderList.vue?vue&type=script&lang=js"
import style0 from "./gOrderList.vue?vue&type=style&index=0&id=3dba34a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dba34a4",
  null
  
)

export default component.exports